<template>

	<footer class="footer-area">
		<div class="footer-top p-4">
			<nav class="footer-nav text-center">
				<ul>
					<li><a :href="$appConfig['link_privacy_policy_'+currentLanguage]" target="_blank">{{ $t('footer.privacy')}} <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a></li>
					<li><a :href="$appConfig['link_terms_use_'+currentLanguage]" target="_blank">{{ $t('footer.terms')}} <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a></li>
					<!-- <li><a :href="$appConfig['link_forum_terms_use_'+currentLanguage]" target="_blank">{{ $t('footer.forum_terms')}} <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a></li> -->
					<li><a :href="$appConfig['link_faq_'+currentLanguage]" target="_blank">{{ $t('footer.faq')}} <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a></li>
				</ul>
			</nav>
		</div>

		<div class="footer-bottom p-4">
			<p>&copy; {{ $t('footer.copyright')}}</p>
		</div>
	</footer>

</template>

<script>
export default {
	name: 'Footer',
	computed: {
		currentLanguage () {
			return this.$root.$i18n.locale;
		}
	}
}
</script>
